// The pure reservation helpers live in @aventuria/client-core (shared with the mobile app);
// only the browser-storage draft stays here.
export * from "@aventuria/client-core/reservations";

/** Keeps the browser's per-session draft of the personalized-trip form (D3). */
export function draftStorage<T>(key: string) {
  return {
    read(): T | null {
      try {
        const raw = window.sessionStorage.getItem(key);
        return raw ? JSON.parse(raw) as T : null;
      } catch { return null; }
    },
    write(value: T) {
      try { window.sessionStorage.setItem(key, JSON.stringify(value)); } catch { /* private mode: no draft */ }
    },
    clear() {
      try { window.sessionStorage.removeItem(key); } catch { /* ignore */ }
    }
  };
}
